enum Role {
  Admin = 'Admin',
  Member = 'Member',
  Owner = 'Owner',
}

export default Role
